import axios from 'axios';

import { API_URL } from 'constants/api';

export const axiosRestApi = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
});
